/**
 * © 2026 Madar.iq — جميع الحقوق محفوظة
 * هذا الملف جزء من منظومة Madar.iq البرمجية.
 * يُحظر نسخه أو تعديله أو توزيعه دون إذن كتابي.
 * All Rights Reserved — Unauthorized use is prohibited.
 */
import React from "react";

const CategoryGrid = ({ categories, selectedCategory, selectedSubCategory, onCategoryClick, theme }) => {
  const cats = (categories || []).filter((c) => Number(c.id) !== 0);

  return (
    <section id="categories-section" className="t3-cats" dir="rtl">
      <div className="t3-container">
        <div className="t3-section-head">
          <div>
            <h2>اكتشف مجموعتنا الفريدة من الأقسام</h2>
            <p>تسوق حسب القسم بسهولة</p>
          </div>
          <button
            type="button"
            className="t3-link-all"
            style={{ color: theme.primary }}
            onClick={() => onCategoryClick(0)}
          >
            عرض جميع الأقسام
          </button>
        </div>

        <div className="t3-cat-scroll">
          {cats.map((cat, idx) => {
            const isActive = selectedCategory === cat.id;
            return (
              <div key={`cat-${cat.id}-${idx}`} className="t3-cat-col">
                <button
                  type="button"
                  className={`t3-cat-card ${isActive ? "is-active" : ""}`}
                  style={isActive ? { borderColor: theme.primary, color: theme.primary } : {}}
                  onClick={() => onCategoryClick(cat.id)}
                >
                  <span className="t3-cat-icon" style={{ background: `${theme.primary}14`, color: theme.primary }}>
                    {cat.icon || "📦"}
                  </span>
                  <strong>{cat.name}</strong>
                  {cat.count > 0 && <small>{cat.count} منتج</small>}
                </button>

                {isActive && cat.subCategories?.length > 0 && (
                  <div className="t3-subcats">
                    {cat.subCategories.map((sub) => {
                      const isSubActive = selectedSubCategory === sub.id;
                      return (
                        <button
                          key={`sub-${sub.id}`}
                          type="button"
                          className={isSubActive ? "is-active" : ""}
                          style={isSubActive ? { background: theme.primary, borderColor: theme.primary } : {}}
                          onClick={(e) => {
                            e.stopPropagation();
                            onCategoryClick(cat.id, sub.id);
                          }}
                        >
                          {sub.name}
                        </button>
                      );
                    })}
                  </div>
                )}
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default CategoryGrid;
